module.exports = __webpack_public_path__ + "fa8e42a2b70a532e61d1ee1ba1a89fe4.svg";